<template>
  <vs-wrapper>
    <vs-alert type="info">
      <v-icon v-if="iconInfo" color="blue lighten-1" :class="iconInfo.class">{{
        iconInfo.icon
      }}</v-icon>
      {{ message }}
    </vs-alert>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { getJobStatusName } from '@/utils/status-formatting'
import { computed } from 'vue'
import VsAlert from '@/components/vision/VsAlert.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'

const props = withDefaults(
  defineProps<{
    isArchived?: boolean
    jobStatus?: string
    hubId?: string
  }>(),
  {
    isArchived: false,
    jobStatus: '',
    hubId: '',
  },
)

const iconInfo = computed(() =>
  props.isArchived ? { icon: 'mdi-archive-arrow-down-outline', class: 'pb-1 pr-1' } : null,
)

const message = computed(() =>
  props.isArchived
    ? 'Job Archived. It can no longer be changed'
    : `Job ${getJobStatusName(props.jobStatus)}. It can no longer be changed`,
)
</script>
